import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { Tag } from "antd";
const { CheckableTag } = Tag;

function TCTag(props) {
  const { tag, id, checkable, checked, onChange } = props;

  const tagColors = [
    "pink",
    "orange",
    "green",
    "red",
    "cyan",
    "blue",
    "purple"
  ];

  const color = tagColors[props.id % tagColors.length];

  return (
    <Tag {...props} color={color}>
      {tag}
    </Tag>
  );
}
export default hot(module)(TCTag);
